import { type AnyObject } from 'antd/lib/_util/type';
import { type IResult } from 'jsonapi-react';
import { type Observable } from 'rxjs';
import { type SiteMenuOrder } from './entities';
import type SiteMenuBeverageOrder from './entities/site-menu-beverage-order';
import type SiteMenuSupplyOrder from './entities/site-menu-supply-order';

export interface ApiHookType {
  get: (
    url: string,
    parameters: AnyObject,
    headers: HeadersInit,
    asBlob?: boolean
  ) => Observable<any>;
  post: (
    url: string,
    data: any,
    parameters: Record<string, unknown>,
    headers: HeadersInit,
    asBlob?: boolean
  ) => Observable<any>;
  put: (
    url: string,
    data: any,
    parameters: Record<string, unknown>,
    headers: HeadersInit
  ) => Observable<any>;
  patch: (
    url: string,
    data: any,
    parameters: Record<string, unknown>,
    headers: HeadersInit
  ) => Observable<any>;
  delete: (
    url: string,
    data: any,
    parameters: Record<string, unknown>,
    headers: HeadersInit
  ) => Observable<any>;
}

interface ClaimsType {
  email: string;
  firstName: string;
  lastName: string;
  id: number;
  customerId: number | null;
  role: Roles;
  customerName: string | null;
}

export interface AuthSession {
  accessToken: string;
  refreshToken: string;
  expirationTime: number;
  claims: ClaimsType;
}

export enum Roles {
  ROLE_CUSTOMER_ADMIN = 0,
  ROLE_HHC_ADMIN = 1,
  ROLE_CUSTOMER_STANDARD = 2,
}
export enum OrderStatus {
  Submitted = 'SUBMITTED',
  Accepted = 'ACCEPTED',
  InPreparation = 'INPREPARATION',
  Completed = 'COMPLETED',
  CanceledByAdmin = 'CANCELEDBYADMIN',
  CanceledByCustomer = 'CANCELEDBYCUSTOMER',
}
export enum Season {
  ss = 'SS',
  fw = 'FW',
}

export enum Status {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
  NeedUpdate = 'NEEDUPDATE',
}
export enum MailTypes {
  INVITATION = 2,
}

export const RolesColors: Record<Roles, string> = {
  [Roles.ROLE_HHC_ADMIN]: 'magenta',
  [Roles.ROLE_CUSTOMER_ADMIN]: 'cyan',
  [Roles.ROLE_CUSTOMER_STANDARD]: 'orange',
};

export interface OrderMeal {
  packageNumber?: number;
  siteMenuOrders: SiteMenuOrder[];
  siteMenuBeverageOrders: SiteMenuBeverageOrder[];
  siteMenuSupplyOrders: SiteMenuSupplyOrder[];
}
export const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const mealTypes: any = {
  allDiets:
    'Cardiac,Diabetic,Diverticulitis,Gluten Friendly,Lactose Friendly,Low Carb,Low Potassium,Low Residue,Low Sodium,Mechanical Soft,Puree,Renal,Vegan,Vegetarian,Vitamin K Friendly',
  allPreferences:
    'No Bbq,No Banana,No Beans,No Beef,No Bones,No Celery,No Cheese,No Chicken,No Cinnamon,No Citrus,No Corn,No Crab,No Eggs,No Fish,No Flour,No Garlic,No Gravy,No Green Peppers,No Hot Dog,No Lemon,No Lime,No MSG,No Mushroom,No Nuts,No Onion,No Oranges,No Pasta,No Peaches,No Pepper,No Pineapple,No Pork,No Potato,No Ravioli,No Raw Fruit,No Raw Vegetables,No Red Meat,No Rice,No Sausage,No Seafood,No Seeds,No Shellfish,No Soy,No Tomato,No Turkey,No Veal',
  allSupplies:
    'Decaf Coffee-Regular Coffee-Tea Bags-Decaf Tea Bags-Sugar Packet-Sugar Canister-Sweet & Low Substitute Packet-Equal Packet-Creamer Canister-Creamer Packet-Honey Packet-Salt Shaker-Pepper Shaker-Salt Packets-Pepper Packets-3 Compartment Foam Plate-6 inch Foam Plate-3 comp. Aluminium tray-12 oz bowls, 12sj20-12 oz foam lids, 20RL-12 oz plastic lids, 20JL-6 oz squat cups, 6SJ12-6 oz lids, 12JL-8 oz coffee cups, 8J8-8 oz coffee lid 8FTL-Sandwich Bags-10 X14 Bags-Napkins-Fork, Plastic-Knife, Plastic-Spoon, Plastic-Soup Spoon-Cultery Kit-Extra Package Bag-Crackers-French Packets-Italian Packets-Ranch Packets',
  children: [
    {
      id: 1,
      value: 'Vegetarian',
      desc: '',
    },
    {
      id: 2,
      value: 'Puree',
      desc: '',
    },
    {
      id: 3,
      value: 'Mechanical Soft',
      desc: '',
    },
    {
      id: 4,
      value: 'Renal',
      desc: '',
    },
    {
      id: 5,
      value: 'Cardiac',
      desc: '',
    },
    {
      id: 6,
      value: 'Gluten Friendly',
      desc: '',
    },
    {
      id: 7,
      value: 'Lactose Friendly',
      desc: '',
    },
    {
      id: 8,
      value: 'Vitamin K Friendly',
      desc: '',
    },
    {
      id: 9,
      value: 'Low Potassium',
      desc: '',
    },
    {
      id: 10,
      value: 'Low Sodium',
      desc: '',
    },
    {
      id: 11,
      value: 'Low Residue',
      desc: '',
    },
    {
      id: 12,
      value: 'Low Carb',
      desc: '',
    },
    {
      id: 13,
      value: 'No Crab',
      desc: '',
    },
    {
      id: 14,
      value: 'No Beef',
      desc: '',
    },
    {
      id: 15,
      value: 'No Bones',
      desc: '',
    },
    {
      id: 16,
      value: 'No Chicken',
      desc: '',
    },
    {
      id: 17,
      value: 'No Turkey',
      desc: '',
    },
    {
      id: 18,
      value: 'No Eggs',
      desc: '',
    },
    {
      id: 19,
      value: 'No Fish',
      desc: '',
    },
    {
      id: 20,
      value: 'No Hot Dog',
      desc: '',
    },
    {
      id: 21,
      value: 'No Sausage',
      desc: '',
    },
    {
      id: 22,
      value: 'No Nuts',
      desc: '',
    },
    {
      id: 23,
      value: 'No Oranges',
      desc: '',
    },
    {
      id: 24,
      value: 'No Pineapple',
      desc: '',
    },
    {
      id: 25,
      value: 'No Green Peppers',
      desc: '',
    },
    {
      id: 26,
      value: 'No Pork',
      desc: '',
    },
    {
      id: 27,
      value: 'No Bbq',
      desc: '',
    },
    {
      id: 28,
      value: 'No Seafood',
      desc: '',
    },
    {
      id: 29,
      value: 'No Red Meat',
      desc: '',
    },
    {
      id: 30,
      value: 'No Ravioli',
      desc: '',
    },
    {
      id: 31,
      value: 'No Shellfish',
      desc: '',
    },
    {
      id: 32,
      value: 'No Veal',
      desc: '',
    },
    {
      id: 33,
      value: 'No Flour',
      desc: '',
    },
    {
      id: 34,
      value: 'No Pasta',
      desc: '',
    },
    {
      id: 35,
      value: 'No Cheese',
      desc: '',
    },
    {
      id: 36,
      value: 'No Mushroom',
      desc: '',
    },
    {
      id: 37,
      value: 'No Soy',
      desc: '',
    },
  ],
  meals: [
    {
      id: 1,
      value: 'Congregate Meals',
      label: 'Congregate Meals',
      desc: '',
      minAllowed: 15,
      hasSpecialDiets: true,
      onlyRegular: false,
      mainType: {
        regular: 'CR',
        diabetic: 'CD',
      },
      children: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
      ],
    },
    {
      id: 2,
      value: 'Fresh Bar Deli Meals',
      label: 'Fresh Bar Deli Meals',
      desc: '',
      minAllowed: 1,
      hasSpecialDiets: false,
      onlyRegular: true,
      mainType: {
        regular: 'D3',
      },
      children: [],
    },
    {
      id: 3,
      value: 'Home Delivered Meals',
      label: 'Home Delivered Meals',
      desc: '',
      minAllowed: 1,
      hasSpecialDiets: true,
      onlyRegular: false,
      mainType: {
        regular: 'R',
        diabetic: 'D',
      },
      children: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
      ],
    },
    {
      id: 4,
      value: 'Chill Meals',
      label: 'Chill Meals',
      desc: '',
      minAllowed: 1,
      hasSpecialDiets: true,
      onlyRegular: false,
      mainType: {
        regular: 'SA',
        diabetic: 'DS',
      },
      children: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
      ],
    },
    {
      id: 5,
      value: 'Frozen Meal',
      label: 'Frozen Meal',
      desc: '',
      minAllowed: 1,
      hasSpecialDiets: true,
      onlyRegular: false,
      mainType: {
        regular: 'RF',
        diabetic: 'DF',
      },
      children: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
      ],
    },
    {
      id: 6,
      value: 'Component Only',
      label: 'Component Only',
      desc: '',
      minAllowed: 1,
      hasSpecialDiets: true,
      onlyRegular: false,
      mainType: {
        regular: 'C',
        diabetic: 'CO',
      },
      children: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
      ],
    },
    {
      id: 7,
      value: 'Cold Reheatable w/ Components 1',
      label: 'Cold Reheatable w/ Components 1',
      desc: '',
      minAllowed: 1,
      hasSpecialDiets: true,
      onlyRegular: false,
      mainType: {
        regular: 'RFC',
        diabetic: 'DFC',
      },
      children: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
      ],
    },
  ],
  beverages: [
    {
      id: 1,
      value: '1% Milk',
      label: '1% Milk',
      mainType: '2 M',
    },
    {
      id: 2,
      value: 'Chocolate Milk',
      label: 'Chocolate Milk',
      mainType: 'CM',
    },
    {
      id: 3,
      value: 'Fortified Water',
      label: 'Fortified Water',
      mainType: 'FW',
    },
    {
      id: 4,
      value: 'Juice',
      label: 'Juice',
      mainType: 'J',
    },
    {
      id: 5,
      value: 'Skim Milk',
      label: 'Skim Milk',
      mainType: 'SM',
    },
    {
      id: 1,
      value: 'Extra 1% Milk',
      label: 'Extra 1% Milk',
      mainType: 'E2%',
    },
    {
      id: 2,
      value: 'Extra Chocolate Milk',
      label: 'Extra Chocolate Milk',
      mainType: 'ECM',
    },
    {
      id: 3,
      value: 'Extra Fortified Water',
      label: 'Extra Fortified Water',
      mainType: 'EFW',
    },
    {
      id: 4,
      value: 'Extra Juice',
      label: 'Extra Juice',
      mainType: 'EJ',
    },
    {
      id: 5,
      value: 'Extra Skim Milk',
      label: 'Extra Skim Milk',
      mainType: 'ESM',
    },
  ],
};

export type ServeType = 'BULK' | 'INDIVIDUAL' | 'TRAY';

export type DataContext<T> = Omit<IResult<T>, 'client'>;

export type ServiceType = 'C1' | 'C2';

export type ElementOf<ArrType> = Exclude<Exclude<ArrType, undefined>, null> extends ReadonlyArray<
  infer ElementType
>
  ? ElementType
  : never;

export interface DisplayConfig {
  showSummary: boolean;
  ['showSummary.includeBeverages']: boolean;
  ['showSummary.includeSupplies']: boolean;
  ['showSummary.includeSpecialDiets']: boolean;
  ['showSummary.includeMealItems']: boolean;
  ['showSummary.includeMealItems.includeMealItemsIngredients']: boolean;
  showMealsPerSite: boolean;
  ['showMealsPerSite.includeBeverages']: boolean;
  ['showMealsPerSite.includeSupplies']: boolean;
  ['showMealsPerSite.includeSpecialDiets']: boolean;
  ['showMealsPerSite.includeMealItems']: boolean;
  ['showMealsPerSite.includeMealItems.includeMealItemsIngredients']: boolean;
  showMealsPerCustomer: boolean;
  ['showMealsPerCustomer.includeBeverages']: boolean;
  ['showMealsPerCustomer.includeSupplies']: boolean;
  ['showMealsPerCustomer.includeSpecialDiets']: boolean;
  ['showMealsPerCustomer.includeMealItems']: boolean;
  ['showMealsPerCustomer.includeMealItems.includeMealItemsIngredients']: boolean;
  showMealsPerRoute: boolean;
  ['showMealsPerRoute.includeBeverages']: boolean;
  ['showMealsPerRoute.includeSupplies']: boolean;
  ['showMealsPerRoute.includeSpecialDiets']: boolean;
  ['showMealsPerRoute.includeMealItems']: boolean;
  ['showMealsPerRoute.includeMealItems.includeMealItemsIngredients']: boolean;
  showPacking: boolean;
  ['showPacking.showPrepacked']: boolean;
  ['showPacking.showBundled']: boolean;
  showLabels: boolean;
}

export type InvoiceStatus = 'PAID' | 'UNPAID' | 'PENDING';
